// extracted by mini-css-extract-plugin
module.exports = {"imageButton":"ZoomModalImage_imageButton__JvfPX","image":"ZoomModalImage_image__0guaC"};